module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"staff_review":"管理員評論","my_review":"我的評論"}}')
  delete Component.options._Ctor
}
